import * as types from '../actions/actionTypes';
// import update from 'immutability-helper';
// state = [] : Start out with no accounts
export default function students(state = [], action){
  switch(action.type){

    case types.GET_STUDENTS:
      return action.students;

    default:
      return state;
  }
}
